import { render, staticRenderFns } from "./BuyBusinessEdit.vue?vue&type=template&id=00f9a265&scoped=true&"
import script from "./BuyBusinessEdit.vue?vue&type=script&lang=js&"
export * from "./BuyBusinessEdit.vue?vue&type=script&lang=js&"
import style0 from "./BuyBusinessEdit.vue?vue&type=style&index=0&id=00f9a265&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f9a265",
  null
  
)

export default component.exports